import React, { useState } from 'react';
import styled from 'styled-components';

import MaterialSymbol from '#/components/basic/icons/MaterialSymbol';
import ToggleSlider from '#/components/basic/inputs/ToggleSlider/ToggleSlider';
import ModalContent from '#/components/basic/modal/components/ModalContent';
import ModalFooterButtons from '#/components/basic/modal/components/ModalFooterButtons';
import SimpleModalOrMobilePage from '#/components/basic/modal/SimpleModalOrMobilePage';
import { closedLargeSpreadMarketOrderModal } from '#/reduxState/exchange/userGuideReducer';
import { staticDispatch } from '#/reduxState/store';

const CenterWrap = styled.div`
  text-align: center;
`;

type Props = {
  spreadPercentage: number;
  onClose: () => void;
  onContinue: () => void;
};

export default function HighSpreadWarningModal({
  spreadPercentage,
  onClose,
  onContinue,
}: Props) {
  const [dontShowAnymore, setDontShowAnymore] = useState(false);
  const handleContinue = () => {
    if (dontShowAnymore) {
      staticDispatch(closedLargeSpreadMarketOrderModal());
    }
    onContinue();
  };
  const handleClose = () => {
    if (dontShowAnymore) {
      staticDispatch(closedLargeSpreadMarketOrderModal());
    }
    onClose();
  };
  return (
    <SimpleModalOrMobilePage
      onClose={handleClose}
      size="small"
      padding="0"
      verticalAlignOnMobile="ceneteredDiv"
    >
      <ModalContent>
        <CenterWrap>
          <MaterialSymbol
            icon="warning"
            fontSize="large"
            color="var(--warnContent)"
          />
          <h2>
            The spread on this market is {Math.round(spreadPercentage)}%. Market
            orders will match with existing orders on the books.
          </h2>
          <ToggleSlider
            checked={dontShowAnymore}
            onChange={setDontShowAnymore}
            inline
          >
            Don't show this message again
          </ToggleSlider>
        </CenterWrap>
      </ModalContent>
      <ModalFooterButtons
        confirmButtonProps={{
          inline: true,
          onClick: handleContinue,
          children: 'Continue Anyway',
        }}
      />
    </SimpleModalOrMobilePage>
  );
}
